import { combineReducers } from 'redux-immutable';

import AchievementsReducer from './AchievementsReducer/AchievementsReducer';
import { BaseAchievementsStore } from './AchievementsReducer/AchievementsReducer.types';
import AlphasReducer from './Alphas/AlphasReducer';
import { AlphasStore } from './Alphas/AlphasReducer.types';
import AnnouncementsReducer from './AnnouncementsReducer/AnnouncementsReducer';
import { AnnouncementsStore } from './AnnouncementsReducer/AnnouncementsReducer.types';
import CompetitionsReducer from './CompetitionsReducer/CompetitionsReducer';
import { CompetitionsStore } from './CompetitionsReducer/CompetitionsReducer.types';
import EventsReducer from './EventsReducer/EventsReducer';
import { EventsStore } from './EventsReducer/EventsReducer.types';
import NotificationsReducer from './NotificationsReducer/NotificationsReducer';
import { NotificationsStore } from './NotificationsReducer/NotificationsReducer.types';
import PerformanceReducer from './Performance/PerformanceReducer';
import { PerformanceStore } from './Performance/PerformanceReducer.types';

export const DashboardReducer = combineReducers<BaseDashboardStoreElement>({
  announcements: AnnouncementsReducer,
  achievements: AchievementsReducer,
  notifications: NotificationsReducer,
  events: EventsReducer,
  competitions: CompetitionsReducer,
  alphas: AlphasReducer,
  performance: PerformanceReducer,
});

export interface BaseDashboardStoreElement {
  achievements: BaseAchievementsStore;
  announcements: AnnouncementsStore;
  notifications: NotificationsStore;
  events: EventsStore;
  competitions: CompetitionsStore;
  alphas: AlphasStore;
  performance: PerformanceStore;
}

export interface BaseDashboardStore {
  dashboard: BaseDashboardStoreElement;
}
